import { default as interactivesSelectors } from './interactives'
export { default as multiSelectSelectors } from './multiSelectQuestion'
export { default as singleSelectSelectors } from './singleSelectQuestion'
export { default as textEntrySelectors } from './textEntry'

export default interactivesSelectors
